import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export interface IMediaDeviceObject {
  showDevices: boolean
}

export interface IMediaDevicesState extends Record<MediaDeviceKind, IMediaDeviceObject> {}

export const initialMediaDevicesState: IMediaDevicesState = {
  audioinput: { showDevices: true },
  audiooutput: { showDevices: true },
  videoinput: { showDevices: true },
}

const mediaDevicesAdapter = createEntityAdapter()

export const mediaDevicesSlice = createSlice({
  name: 'mediaDevices',
  initialState: mediaDevicesAdapter.getInitialState(initialMediaDevicesState),
  reducers: {
    resetMediaDevicesState: (state) => ({ ...state, ...initialMediaDevicesState }),
    setMediaDevicesState: (state, action: PayloadAction<IMediaDevicesState>) => ({
      ...state,
      ...action.payload,
    }),
    setMediaDevice: (
      state,
      action: PayloadAction<
        Partial<{ [key in keyof IMediaDevicesState]: IMediaDevicesState[key] }>
      >,
    ) => ({
      ...state,
      ...action.payload,
    }),
  },
})

export const { resetMediaDevicesState, setMediaDevicesState, setMediaDevice } =
  mediaDevicesSlice.actions

export const { selectAll: mediaDevicesSelector } = mediaDevicesAdapter.getSelectors(
  (state: RootState) => state[mediaDevicesSlice.name],
)

export const selectMediaDevicesState = (state: RootState) => state.mediaDevices
